module.exports = __webpack_public_path__ + "static/media/pid_art.208ba4b9.png";